import citiesData from './DEMOGRAPHIC_MAP_US_CITIES_BIGGEST_50.csv';

const parsedCitiesData = JSON.parse(JSON.stringify(citiesData));

export const DEMOGRAPHIC_MAP_US_CITIES = () => parsedCitiesData;
